import type { AnalyticsRange, ProjectAnalytics } from './api'

/**
 * A plausible-but-FAKE analytics dataset, shown blurred behind the Pro upsell for
 * free users. Because free users never call the real analytics endpoint, no real
 * numbers ever reach the browser — DevTools only ever sees these placeholders.
 */
export function fakeAnalytics(range: AnalyticsRange = '30d'): ProjectAnalytics {
  const points = 30
  const today = new Date()
  const series = Array.from({ length: points }, (_, i) => {
    const d = new Date(today)
    d.setUTCDate(d.getUTCDate() - (points - 1 - i))
    const wave = 46 + Math.round(28 * Math.sin(i / 3.1) + (i % 7) * 5)
    const views = Math.max(9, wave)
    return { day: d.toISOString().slice(0, 10), views, uniques: Math.max(6, Math.round(views * 0.7)) }
  })
  const views = series.reduce((total, p) => total + p.views, 0)
  const uniques = Math.round(views * 0.68)
  return {
    range,
    totals: {
      views,
      uniques,
      viewsPrev: Math.round(views * 0.82),
      uniquesPrev: Math.round(uniques * 0.85),
    },
    series,
    granularity: 'day',
    topPages: [
      { path: '/', views: Math.round(views * 0.44) },
      { path: '/productos', views: Math.round(views * 0.21) },
      { path: '/sobre-nosotros', views: Math.round(views * 0.14) },
      { path: '/contacto', views: Math.round(views * 0.09) },
    ],
    topSources: [
      { source: 'google.com', views: Math.round(views * 0.38) },
      { source: 'Directo', views: Math.round(views * 0.29) },
      { source: 'instagram.com', views: Math.round(views * 0.16) },
      { source: 'facebook.com', views: Math.round(views * 0.08) },
    ],
    topCountries: [
      { country: 'MX', views: Math.round(views * 0.62) },
      { country: 'US', views: Math.round(views * 0.18) },
      { country: 'ES', views: Math.round(views * 0.09) },
      { country: 'CO', views: Math.round(views * 0.06) },
    ],
    countriesCount: 12,
    // Los mismos valores crudos que guarda el worker: el panel los traduce al
    // pintarlos. Traducidos aquí no casarían con el orden ni con los colores.
    devices: [
      { device: 'Móvil', views: Math.round(views * 0.61) },
      { device: 'Escritorio', views: Math.round(views * 0.32) },
      { device: 'Tablet', views: Math.round(views * 0.07) },
    ],
    topCampaigns: [],
  }
}
